export default __webpack_public_path__ + "static/media/refer_friend_image.40eaf4c8.png";